// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1805 ? "25f4ac2a" : chunkId) + "." + {"1805":"30dc3b0963889998","5041":"4f5e1fdff99007de"}[chunkId] + ".js";
};